import {
  EmployeePerformanceFormStateTypes,
  EmployeePerformanceFormActionTypes,
} from "./EmployeePerformanceForm.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: EmployeePerformanceFormStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const EmployeePerformanceFormReducer = (
  state: EmployeePerformanceFormStateTypes = INITIAL_STATE,
  action: any
): EmployeePerformanceFormStateTypes => {
  switch (action.type) {
    case EmployeePerformanceFormActionTypes.FETCH_ALL_EMPLOYEE_PERFORMANCE_FORM:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case EmployeePerformanceFormActionTypes.FETCH_ALL_EMPLOYEE_PERFORMANCE_FORM_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case EmployeePerformanceFormActionTypes.FETCH_ALL_EMPLOYEE_PERFORMANCE_FORM_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EmployeePerformanceFormActionTypes.FETCH_ALL_EMPLOYEE_PERFORMANCE_FORM_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case EmployeePerformanceFormActionTypes.FETCH_ONE_EMPLOYEE_PERFORMANCE_FORM:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case EmployeePerformanceFormActionTypes.FETCH_ONE_EMPLOYEE_PERFORMANCE_FORM_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case EmployeePerformanceFormActionTypes.FETCH_ONE_EMPLOYEE_PERFORMANCE_FORM_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EmployeePerformanceFormActionTypes.FETCH_ONE_EMPLOYEE_PERFORMANCE_FORM_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default EmployeePerformanceFormReducer;
